<template>
  <div class="page">
    <div class="container">

      <element-processor @submit="submit" :data="processorData" @submitOtherEst="submitOtherEst">
        <element-processor-step :data="processorData.steps[0]">
          <ul class="form-item-list">
            <li><h3>고객 정보</h3></li>
             
            <template v-if="false">
              <!-- 주석처리하지 않고 보이지 않도록 설정함. -->
              <li><element-textbox v-model="processorData.steps[0].formData.name.value" :error="processorData.steps[0].formData.name.error" :label="processorData.steps[0].formData.name.label" :placeholder="processorData.steps[0].formData.name.label" /></li>
            </template>

            <li><element-spread-select v-model="processorData.steps[0].formData.sex.value" :error="processorData.steps[0].formData.sex.error" :label="processorData.steps[0].formData.sex.label" :items="processorData.steps[0].formData.sex.items" /></li>
            <li><element-textbox v-model="processorData.steps[0].formData.birth.value" :error="processorData.steps[0].formData.birth.error" :label="processorData.steps[0].formData.birth.label" :placeholder="processorData.steps[0].formData.birth.placeholder" /></li>
            <div class="form-item-caution">정확한 보험료 산출을 위해 활용됩니다.</div>
            <li><element-spread-select v-model="processorData.steps[0].formData.usage.value" :error="processorData.steps[0].formData.usage.error" :label="processorData.steps[0].formData.usage.label" :items="processorData.steps[0].formData.usage.items" /></li>
          </ul>
          <ul class="form-item-list">
            <li><element-spread-select v-model="processorData.steps[0].formData.job.value" :error="processorData.steps[0].formData.job.error" :label="processorData.steps[0].formData.job.label" :items="processorData.steps[0].formData.job.items" /></li>
          </ul>
          <div class="form-item-caution">찾는 직업이 없는경우, 가장 비슷한 직업으로 선택하신 후 상담예약에 내용을 남겨주시면 해당하는 직업으로 변경해 드립니다.</div>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[1]">
          <ul class="form-item-list">
            <li><h3>보장항목</h3></li>
            <li><element-select v-model="processorData.steps[1].formData.insureDuration.value" :error="processorData.steps[1].formData.insureDuration.error" :label="processorData.steps[1].formData.insureDuration.label" :placeholder="processorData.steps[1].formData.insureDuration.placeholder" :items="processorData.steps[1].formData.insureDuration.items" :dropbox="processorData.steps[1].formData.insureDuration.dropbox"/></li>
            <li v-for="(options, index) in processorData.steps[1].formData.insureOptions" :key="index">
              <element-content-checkbox @status="popup" v-model="processorData.steps[1].formData.insureOptions[index].value" :error="processorData.steps[1].formData.insureOptions[index].error" :label="processorData.steps[1].formData.insureOptions[index].label" :items="processorData.steps[1].formData.insureOptions[index].items" :index="index" :requirement="processorData.steps[1].formData.insureOptions[index].requirement"/>
            </li>
          </ul>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[2]">
          <ul class="form-item-list" id="history-of-treatment">
            <li><h3>치료이력</h3></li>

            <li><element-textbox v-model="processorData.steps[2].formData.name.value" 
              :error="processorData.steps[2].formData.name.error" 
              :label="processorData.steps[2].formData.name.label" 
              :placeholder="processorData.steps[2].formData.name.label" /></li>
            <li><element-textbox v-model="processorData.steps[2].formData.birth.value" 
              :error="processorData.steps[2].formData.birth.error" 
              :label="processorData.steps[2].formData.birth.label" 
              :placeholder="processorData.steps[2].formData.birth.placeholder" /></li>

            <li id="history-of-treatment-item"><element-radio v-model="processorData.steps[2].formData.history.value" :error="processorData.steps[2].formData.history.error" :label="processorData.steps[2].formData.history.label" :items="processorData.steps[2].formData.history.items" /></li>
            <li id="history-of-treatment-item"><element-radio v-model="processorData.steps[2].formData.inject.value" :error="processorData.steps[2].formData.inject.error" :label="processorData.steps[2].formData.inject.label" :items="processorData.steps[2].formData.inject.items" /></li>
            <li id="history-of-treatment-item">
              <element-checkbox
                v-model="processorData.steps[2].formData.have.value"
                :error="processorData.steps[2].formData.have.error"
                :label="processorData.steps[2].formData.have.label"
                :items="processorData.steps[2].formData.have.items" />
            </li>
          </ul>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[3]">
          <include-estimate-auth-self :data="processorData.steps[0]" @updateprocessorData="updateprocessorData"/>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[4]">
          <ul class="form-item-list">
            <li class="is-multiple">
              <element-calendar v-model="processorData.steps[4].formData.consultDate.value" :error="processorData.steps[4].formData.consultDate.error" :label="processorData.steps[4].formData.consultDate.label" :placeholder="processorData.steps[4].formData.consultDate.placeholder" />
              <element-time-select v-model="processorData.steps[4].formData.consultTime.value" :date="processorData.steps[4].formData.consultDate.value" :error="processorData.steps[4].formData.consultTime.error" :label="processorData.steps[4].formData.consultTime.label" :placeholder="processorData.steps[4].formData.consultTime.placeholder" />
            </li>
            <li><element-textarea v-model="processorData.steps[4].formData.consultRemark.value" :error="processorData.steps[4].formData.consultRemark.error" :label="processorData.steps[4].formData.consultRemark.label" :placeholder="processorData.steps[4].formData.consultRemark.placeholder" /></li>
            <li><div class="form-item-caution">입력하신 내용을 바탕으로 상담원이 상담 전 확인 및 관련 내용을 준비하여 상담을 진행합니다.</div></li>
          </ul>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[5]">
          <include-estimate-complete :data="processorData.steps[5]" />
        </element-processor-step>
        <element-processor-step :data="processorData.steps[6]">
          <include-other-estimate :data="processorData.steps[6]"  :type="processorData.title"/>
        </element-processor-step>
        <transition name="popup">
          <element-popup @status="popup" :process_title="processorData.title" v-model="processorData.steps[1].formData.insureOptions[statusPopup.option].value" @checkPopup="checkValue" :label="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].label"
          :subLabel="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].subLabel" v-if="statusPopup.popup" :statusPopup="statusPopup" :data="processorData.steps[1].formData.insureOptions[statusPopup.option]"
          :description="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].description">
          </element-popup>
        </transition>
      </element-processor>
    </div>
  </div>
</template>
<script>

import moment from 'moment'

export default {
  data(){
    return {
      statusPopup: {
        popup: false,
        index: '',
        option: -1,
      },
      moment: moment,
      processorData: {
        title: "운전자보험 견적서",
        cureData: true,
        steps: [
          {
            title: "고객 정보",
            formData: {
              sex: {
                label: "성별",
                value: "",
                error: "",
                items: [
                  { value: "남자", label: "남자" },
                  { value: "여자", label: "여자" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              birth: {
                label: "생년월일",
                value: "",
                error: "",
                placeholder: "생년월일 6자리 입력",
                validations: [
                  { type: "required", message: "필수항목입니다" },
                  { type: "birth", message: "예) 950101" }
                ]
              },
              usage: {
                label: "차량 용도",
                value: "",
                error: "",
                items: [
                  { value: "자가용", label: "자가용" },
                  { value: "영업용", label: "영업용" }
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              job: {
                label: "직업",
                value: "",
                error: "",
                items: [
                  { value: "사무,전문직", label: "사무,전문직" },
                  { value: "운수,건설직", label: "운수,건설직" },
                  { value: "판매,서비스직", label: "판매,서비스직" },
                  { value: "영업용 운전직", label: "영업용 운전직" },
                  { value: "학생,주부", label: "학생,주부" },
                  { value: "무직", label: "무직" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              }
            }
          },
          {
            title: "보장항목",
            formData:
            {
              insureDuration: {
                label: "보험 기간",
                error: "",
                dropbox: "운전자보험은 자동차 기술 발전 속도가 빠르므로 보험기간을 짧게 선택하는 것이 유리합니다.(기술 발전 예시: 무인자동차, 자동주행기술, 드론형 자동차 등)",
                placeholder: "보험 기간 / 납입 기간을 선택하세요",
                value: "20년만기 20년납",
                items: [
                  { value: "20년만기 20년납", label: "20년만기 20년납" },
                  { value: "15년만기 15년납", label: "15년만기 15년납" },
                  { value: "10년만기 10년납", label: "10년만기 10년납" },
                  { value: "5년만기 5년납", label: "5년만기 5년납" },
                  { value: "30년납 80세만기", label: "30년납 80세만기" },
                  { value: "20년납 80세만기", label: "20년납 80세만기" },
                  { value: "30년납 100세만기", label: "30년납 100세만기" },
                  { value: "20년납 100세만기", label: "20년납 100세만기" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              insureOptions: [
              {
                label: "보장 내용",
                requirement: true,
                value: [
                  { label: "교통상해 처리지원금", value: "1억원" },
                  { label: "교통사고 변호사비", value: "2,000만원" },
                  { label: "교통사고 벌금", value: "2,000만원" },
                  { label: "자동차 부상치료비", value: "600만원" },
                ],
                error: "",
                items: [
                  { value: "교통상해 처리지원금", label: "교통상해 처리지원금", description: [
                    { value: "자동차운전중(이륜차 제외) 대인사고로 피보험자가 피해자 사망, 일반교통사고로 중상해를 입힌경우, 중대법규위반 교통사고로 42일 진단받은 경우 가입금액 한도로 실손보상" }
                  ], subLabel: "1억원", link: { name: "Home" },
                    options: [
                      { value: "1억원", label: "1억원" },
                      { value: "5,000만원", label: "5,000만원" },
                      { value: "3,000만원", label: "3,000만원" },
                      { value: "미가입", label: "미가입" },
                    ] },
                  { value: "교통사고 변호사비", label: "교통사고 변호사비", description: [
                    { value: "자동차운전중(이륜차 제외) 대인사고로 피보험자가 구속 또는 정식 기소되어 변호사 선임비용을 부담한 경우 가입금액 한도로 실손보상" }
                  ], subLabel: "2,000만원", link: { name: "Home" },
                    options: [
                      { value: "2,000만원", label: "2,000만원" },
                      { value: "1,000만원", label: "1,000만원" },
                      { value: "500만원", label: "500만원" },
                      { value: "300만원", label: "300만원" },
                      { value: "미가입", label: "미가입" },
                    ] },
                  { value: "교통사고 벌금", label: "교통사고 벌금", description: [
                    { value: "자동차운전중(이륜차 제외) 대인사고로 피보험자가 벌금 확정판결을 받을 경우 그 확정판결 벌금액을 실손보상" }
                  ], subLabel: "2,000만원", link: { name: "Home" },
                    options: [
                      { value: "2,000만원", label: "2,000만원" },
                      { value: "미가입", label: "미가입" },
                    ] },
                  { value: "자동차 부상치료비", label: "자동차 부상치료비", description: [
                    { value: "교통사고로 피보험자가 신체에 상해를 입고 자동차손해배상보장법 시행령에서 정한 상해급수 1~14급을 받은 경우 급수에 따라 가입금액 차등 지급. 보험료는 상해급수 1~3급 기준으로 표시함." }
                  ], subLabel: "600만원", link: { name: "Home" },
                    options: [
                      { value: "600만원", label: "600만원" },
                      { value: "300만원", label: "300만원" },
                    ] },
                ],
              },
              {
                label: "추가 특약",
                value: [],
                requirement: false,
                error: "",
                items: [
                  { value: "상해사망", label: "상해사망", description: [
                    { value: "상해사고(교통사고 포함)로 피보험자가 사망한 경우 가입금액 지급" }
                  ], subLabel: "미가입", link: { name: "Home" },
                    options: [
                      { value: "2억원 이상", label: "2억원 이상" },
                      { value: "2억원 이내", label: "2억원 이내" },
                      { value: "1억원 한도", label: "1억원 한도" },
                      { value: "미가입", label: "미가입" },
                    ] },
                  { value: "상해후유장해", label: "상해후유장해", description: [
                    { value: "상해사고로 피보험자가 장해지급률이 3% 이상에 해당하는 장해상태가 된 경우 가입금액을 장해지급률에 비례하여 지급" }
                  ], subLabel: "미가입", link: { name: "Home" },
                    options: [
                      { value: "5,000만원 이상", label: "5,000만원 이상" },
                      { value: "5,000만원 이내", label: "5,000만원 이내" },
                      { value: "3,000만원 이내", label: "3,000만원 이내" },
                      { value: "미가입", label: "미가입" },
                    ] },
                  { value: "화상치료비", label: "화상치료비", description: [
                    { value: "상해사고로 피보험자가 심재성 2도 이상의 화상 진단을 받고, 수술을 받은 경우 사고당 가입금액 지급" }
                  ], subLabel: "미가입", link: { name: "Home" },
                    options: [
                      { value: "100만원이상", label: "100만원이상" },
                      { value: "100만원이내", label: "100만원이내" },
                      { value: "50만원이내", label: "50만원이내" },
                      { value: "미가입", label: "미가입" },
                    ] },
                  { value: "골절치료비", label: "골절치료비", description: [
                    { value: "상해사고로 피보험자가 골절로 진단되어 수술 받은 경우 한 사고당 가입금액 지급" }
                  ], subLabel: "미가입", link: { name: "Home" },
                    options: [
                      { value: "100만원이상", label: "100만원이상" },
                      { value: "100만원이내", label: "100만원이내" },
                      { value: "50만원이내", label: "50만원이내" },
                      { value: "미가입", label: "미가입" },
                    ] },
                  { value: "일상생활배상책임", label: "일상생활배상책임", description: [
                    { value: "일상생활중 발생한 사고로 피보험자가 타인의 신체 또는 재물(자기부담금 20만원)에 손해를 입힌 경우 배상 책임액을 가입금액 한도로 지급" }
                  ], subLabel: "미가입", link: { name: "Home" },
                    options: [
                      { value: "1억원", label: "1억원" },
                      { value: "미가입", label: "미가입" },
                    ] },
                ]
              }]
            }
          },
          {
            title: "치료이력",
            formData: {
              name: {
                label: "이름",
                value: "",
                error: "",
                placeholder: "이름 입력",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              birth: {
                label: "생년월일",
                value: "",
                error: "",
                placeholder: "생년월일 6자리 입력",
                validations: [
                  { type: "required", message: "필수항목입니다" },
                  { type: "birth", message: "예) 950101" }
                ]
              },
              history: {
                label: "최근 3개월 이내 치료",
                value: "",
                error: "",
                items: [
                  { value: "치료", label: "치료" },
                  { value: "검사", label: "검사" },
                  { value: "없음", label: "없음" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              inject: {
                label: "최근 5년 이내 치료",
                value: "",
                error: "",
                items: [
                  { value: "2년 내 입원 및 수술", label: "2년 내 입원 및 수술" },
                  { value: "2~5년내 입원 및 수술", label: "2~5년내 입원 및 수술" },
                  { value: "없음", label: "없음" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              have: {
                label: "관리하고 있는 질병",
                value: "",
                error: "",
                items: [
                  { value: "당뇨병", label: "당뇨병" },
                  { value: "고혈압", label: "고혈압" },
                  { value: "고지혈증", label: "고지혈증" },
                  { value: "뇌혈관질환", label: "뇌혈관질환" },
                  { value: "심혈관질환", label: "심혈관질환" },
                  { value: "없음", label: "없음" },
                ],
                validations: [
                  { type: "array", message: "필수항목입니다" }
                ]
              },
            }
          },
          {
            title: "본인 확인",
            formData: {
              // haslogin: {
              //   value: "",
              //   validations: [
              //     { type: "required", message: "-" }
              //   ]
              // },
              phone: {
                label: "휴대폰 번호",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              name: {
                label: "이름",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              email: {
                label: "이메일",
                value: ""
              },
              birth: {
                label: "생년월일",
                value: "",
                validations: [
                  { type: "required", message: "-" },
                ]
              },
            }
          },
          {
            title: "상담 예약",
            formData: {
              consultDate: {
                label: "상담 예약 일시",
                value: new Date(),
                error: "",
                placeholder: "날짜"
              },
              consultTime: {
                label: "상담 예약 일시",
                value: "",
                error: "",
                placeholder: "시간",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultRemark: {
                label: "상담 전 남기실 말씀",
                value: "",
                error: "",
                placeholder: "특별히 보장 받고 싶은 보장 항목, 기간, 금액 또는 현재 가입 중인 보험 그리고 상담 전 남기실 말씀을 입력하십시오. (200자 이내)"
              },
            }
          },
          {
            title: "비교견적 신청이 완료되었습니다.",
            label: "입력하신 정보를 바탕으로 쉽게 추가 견적서를 신청하시겠습니까?"
          },
          {
            title: "다른 보험 표준 견적서 받아보기",
            label: "",
            value: []
          }
        ], // steps
        reservation_inflow_referer_source: '',
      }
    }
  },
  created() {
    const { date, time } = this.$getDefaultConsultTime();

    if (date !== '') {
      this.processorData.steps[4].formData.consultDate.value = date;
    }

    this.processorData.steps[4].formData.consultTime.value = time;

    if (this.$route.query.refin) {
      this.reservation_inflow_referer_source = this.$route.query.refin;
    }
  },
  methods: {
    submit( finalData ) {
      var tmp = JSON.parse(JSON.stringify(finalData["상담 예약"]));
      // 상담 예약 제거
      delete finalData["상담 예약"];
      //가입자 , 자필서명
      if(this.$route.query) {
        if(this.$route.query.procstep == "가입자" || this.$route.query.procstep == "본인 확인" || this.$route.query.procstep == "자필서명") {
          this.$store.dispatch( "estimate/createItems", finalData);
        }else if(this.$route.query.procstep == "상담 예약") {
          tmp.step_datas.insureName = { value: finalData.title }
          tmp.step_datas.name = {  value: this.processorData.steps[3].formData.name.value }
          tmp.step_datas.phone = { value: this.processorData.steps[3].formData.phone.value}
          var reservation_data = {
            customer_id: finalData.customer_id,
            "전화상담": tmp
          }

          if (this.reservation_inflow_referer_source !== '') {
            reservation_data.reservation_inflow_referer_source = this.reservation_inflow_referer_source;
          }
          // 전화상담 예약 전송
          this.$store.dispatch( "reservation/createItems", reservation_data );
        }
      }
    },
    popup: function( status ) {
      this.statusPopup = status;
    },
    checkValue: function( value ) {
      var insureOptionsObj = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option];
      insureOptionsObj.items[this.statusPopup.index].subLabel = value;

      var Vidx = insureOptionsObj.value.findIndex(o => o.label === insureOptionsObj.items[this.statusPopup.index].label);
      if(Vidx >= 0){

        if(value === '미가입' && !insureOptionsObj.requirement){
          // 필수 보장항목이 아니고, 미가입하는경우는 value 목록에서 제거
          insureOptionsObj.value.splice(Vidx, 1);
        }else{
          // 이외 값 변경
          // 단, 값이 Array 인경우가 있으므로 확인 ( 다중선택 가능한경우 )
          if(Array.isArray(insureOptionsObj.value[Vidx].value)) {
            var VIidx = insureOptionsObj.value[Vidx].value.indexOf(value);
            // 이미 arr 값이 있는경우 제거
            if(VIidx >= 0){
              //단, 최소 하나이상 선택하도록 해야하므로
              if(insureOptionsObj.value[Vidx].value.length > 0) insureOptionsObj.value[Vidx].value.splice(VIidx, 1);
            }else{
              // 추가
              insureOptionsObj.value[Vidx].value.push(value)
            }
            insureOptionsObj.items[this.statusPopup.index].subLabel = insureOptionsObj.value[Vidx].value.join();
          }else{
            insureOptionsObj.value[Vidx].value = value;
          }
        }
      }else{
        // value 목록에 없는 경우
        if(value != '미가입'){
          // 미가입 아닌경우 값 추가
          var tmp = { label: insureOptionsObj.items[this.statusPopup.index].value, value: value };
          insureOptionsObj.value.push( tmp )
        }
      }
    },
    updateprocessorData: function (data){
      //this.processorData.steps[3].formData.haslogin.value = data.haslogin;
      this.processorData.steps[3].formData.phone.value = data.phone;
      this.processorData.steps[3].formData.name.value = data.name;
      this.processorData.steps[3].formData.email.value = data.email;
      this.processorData.steps[3].formData.birth.value = data.birth;
    },
    submitOtherEst() {
      var tmp = {
        customer_id: this.$store.state.customer.profile._id,
        "전화상담": {
          step_datas: {
            insureName: { value: "" },
            name: {  value: this.processorData.steps[3].formData.name.value },
            phone: { value: this.processorData.steps[3].formData.phone.value },
            consultDate: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultDate.value },
            consultTime: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultTime.value },
            consultRemark: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value ? this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value : "없음"}
          }
        }
      }
      var ost_data = this.processorData.steps[this.processorData.steps.length - 1];
      if(ost_data.value.length > 0) {
        ost_data.value.forEach(o => {
          tmp["전화상담"].step_datas.insureName.value = o

          if (this.reservation_inflow_referer_source !== '') {
            tmp.reservation_inflow_referer_source = this.reservation_inflow_referer_source;
          }

          this.$store.dispatch( "reservation/createItems", tmp );
        })
      }
    }
  }
}
</script>
